import axios from 'axios';
import swal from 'sweetalert';

export default class Checkout {

    updateQty(uid,qty,inject) {
        axios.post("./checkout/update",{uid,qty}).then(function (response) {
            if(response.data.content){
                inject.innerHTML = response.data.content;
                window.App.common.init(inject);
            }
            if(response.data.js && typeof response.data.js == 'object'){
                response.data.js.forEach((script)=>{
                    (new Function(script)).call();
                });
            }
        }).catch(function (error) {
            swal("Hata!", "Bilinmeyen bir hata oluştu!", "error");
        });
    }
    
    remove(uid,inject) {
        swal({
            title: "Emin misiniz?",
            text: "Bu ürünü sepetinizden silmek istediğinize emin misiniz?",
            icon: "warning",
            buttons: ["İptal!", "Evet Sil!"],
            dangerMode: true
        })
        .then((willDelete) => {
            if (willDelete) {
                axios.post("./checkout/remove",{uid}).then(function (response) {
                    if(response.data.content){
                        inject.innerHTML = response.data.content;
                        window.App.common.init(inject);
                    }
                    if(response.data.js && typeof response.data.js == 'object'){
                        response.data.js.forEach((script)=>{
                            (new Function(script)).call();
                        });
                    }
                }).catch(function (error) {
                    swal("Hata!", "Bilinmeyen bir hata oluştu!", "error");
                });
            }
        });
    }


    empty(inject) {
        swal({
            title: "Emin misiniz?",
            text: "Sepetinizdeki tüm ürünleri silmek istediğinize emin misiniz?",
            icon: "warning",
            buttons: ["İptal!", "Evet Sil!"],
            dangerMode: true
        })
        .then((willDelete) => {
            if (willDelete) {
                axios.post("./checkout/empty").then(function (response) {
                    if(response.data.content){
                        inject.innerHTML = response.data.content;
                        window.App.common.init(inject);
                    }
                    if(response.data.js && typeof response.data.js == 'object'){
                        response.data.js.forEach((script)=>{
                            (new Function(script)).call();
                        });
                    }
                }).catch(function (error) {
                    swal("Hata!", "Bilinmeyen bir hata oluştu!", "error");
                });
            }
        });
    }

}